import { render, staticRenderFns } from "./cycle-current-badge.vue?vue&type=template&id=1c789dc4&scoped=true"
import script from "./cycle-current-badge.vue?vue&type=script&lang=js"
export * from "./cycle-current-badge.vue?vue&type=script&lang=js"
import style0 from "./cycle-current-badge.vue?vue&type=style&index=0&id=1c789dc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c789dc4",
  null
  
)

export default component.exports